import { AppState } from "webapp/enums/AppState";

class NavigationServiceState {
  nextState = 0;
  previousState = 0;
  params = {};
  constructor(nextState = undefined, previousState = undefined, params = {}) {
    this.nextState = nextState;
    this.previousState = previousState;
    if (typeof params !== "object") {
      params = {};
    }
    this.params = params;
  }

  getNextState(appState) {
    if (typeof this.nextState === "function") {
      return this.nextState(appState);
    } else if (typeof this.nextState === "number") {
      return this.nextState;
    }
    return undefined;
  }

  getPreviousState(appState) {
    if (typeof this.previousState === "function") {
      return this.previousState(appState);
    } else if (typeof this.previousState === "number") {
      return this.previousState;
    }
    return undefined;
  }
}

export default class NavigationService {
  states = new Map();
  defaultState = 0;
  customerInfoPagination = [];

  static partnerNaviServices = new Map();

  /**
   * Gets the NavigationServiceState for the given AppState value.
   * @param {AppState} stateId
   * @returns AppState
   */
  getState(stateId = 0) {
    const state = this.states.get(stateId);
    return state;
  }

  setState(stateId = 0, state = null) {
    if (!(state instanceof NavigationServiceState)) {
      return;
    }
    this.states.set(stateId, state);
  }

  /**
   * Returns the NavigationServiceState for the given partner code
   * @returns NavigationServiceState
   */
  static getService(portalUser) {
    const params = new URLSearchParams(window.location.search);
    if (portalUser === "PORTAL_USER") {
      return DefaultNavigationServiceV2;
    } else if (params && params.has("lg")) {
      const service = this.partnerNaviServices.get(params.get("lg"));
      if (service) {
        console.log("getService service: ", service);
        return service;
      }
    }
    return DefaulNavigationService;
  }
}

//--------------------//
// Default Navigation //
//--------------------//

//WHERE (Origin) - WHO (User) - WHAT (Service) - WHERE (Dest)
const DefaulNavigationService = new NavigationService();
DefaulNavigationService.customerInfoPagination = [
  AppState.ConfirmCustomer,
  AppState.ConfirmVehicle,
  AppState.SelectService,
  AppState.ConfirmInformation,
];

// WHERE (Origin)
DefaulNavigationService.defaultState = AppState.LocateUser;
DefaulNavigationService.states.set(
  AppState.LocateUser,
  new NavigationServiceState(AppState.ConfirmCustomer, undefined, {
    isHomeScreen: true,
  }),
);

// WHO (User)
DefaulNavigationService.states.set(
  AppState.ConfirmCustomer,
  new NavigationServiceState(AppState.ConfirmVehicle, AppState.LocateUser),
);
DefaulNavigationService.states.set(
  AppState.ConfirmVehicle,
  new NavigationServiceState(AppState.SelectService, AppState.ConfirmCustomer),
);

// WHAT (Service)
DefaulNavigationService.states.set(
  AppState.SelectService,
  new NavigationServiceState((state) => {
    return state.Service.toUpperCase() === "TOW" ? AppState.SelectDestination : AppState.ConfirmInformation;
  }, AppState.ConfirmVehicle),
);

// WHERE (Dest)
DefaulNavigationService.states.set(
  AppState.ConfirmInformation,
  new NavigationServiceState(AppState.LocatingProvider, (state) => {
    return state.Service.toUpperCase() === "TOW" ? AppState.SelectDestination : AppState.SelectService;
  }),
);

//----------------------//
// Travelers Navigation //
//----------------------//

//WHO (User) - WHAT (Service) - WHERE (Origin) - WHERE (Dest)
const TVLNavigationService = new NavigationService();
TVLNavigationService.customerInfoPagination = [
  AppState.ConfirmCustomer,
  AppState.MemberInformation,
  AppState.ConfirmVehicle,
  AppState.SelectService,
  AppState.ConfirmInformation,
];
TVLNavigationService.defaultState = AppState.ConfirmCustomer;

// WHO (User)
TVLNavigationService.states.set(
  AppState.ConfirmCustomer,
  new NavigationServiceState(AppState.MemberInformation, undefined, {
    isHomeScreen: true,
  }),
);
TVLNavigationService.states.set(
  AppState.MemberInformation,
  new NavigationServiceState(undefined, AppState.ConfirmCustomer),
);
TVLNavigationService.states.set(
  AppState.ConfirmVehicle,
  new NavigationServiceState(AppState.SelectService, AppState.MemberInformation),
);

// WHAT (Service)
TVLNavigationService.states.set(
  AppState.SelectService,
  new NavigationServiceState(AppState.LocateUser, AppState.ConfirmVehicle),
);

// WHERE (Origin)
TVLNavigationService.states.set(
  AppState.LocateUser,
  new NavigationServiceState((state) => {
    return state.Service.toUpperCase() === "TOW" ? AppState.SelectDestination : AppState.ConfirmInformation;
  }, AppState.SelectService),
);

// WHERE (Dest)
TVLNavigationService.states.set(
  AppState.SelectDestination,
  new NavigationServiceState(AppState.ConfirmInformation, AppState.LocateUser),
);

// Confirm Screen
TVLNavigationService.states.set(
  AppState.ConfirmInformation,
  new NavigationServiceState(AppState.LocatingProvider, (state) => {
    return state.Service.toUpperCase() === "TOW" ? AppState.SelectDestination : AppState.LocateUser;
  }),
);

NavigationService.partnerNaviServices.set("TVL", TVLNavigationService);

//--------------------//
// Navigation Flow v2 //
//--------------------//

//WHO (User) - WHAT (Service) - WHERE (Origin) - WHERE (Dest)
const DefaultNavigationServiceV2 = new NavigationService();
DefaultNavigationServiceV2.customerInfoPagination = [
  AppState.ConfirmCustomer,
  AppState.MemberSearch,
  AppState.MemberInformation,
  AppState.ConfirmVehicle,
  AppState.SelectService,
  AppState.ConfirmInformation,
];
DefaultNavigationServiceV2.defaultState = AppState.ConfirmCustomer;

// WHO (User)
DefaultNavigationServiceV2.states.set(
  AppState.ConfirmCustomer,
  new NavigationServiceState(AppState.MemberSearch, undefined, {
    isHomeScreen: true,
  }),
);

DefaultNavigationServiceV2.states.set(
  AppState.MemberSearch,
  new NavigationServiceState(AppState.MemberInformation, AppState.ConfirmCustomer),
);
DefaultNavigationServiceV2.states.set(
  AppState.MemberInformation,
  new NavigationServiceState(undefined, AppState.MemberSearch),
);

DefaultNavigationServiceV2.states.set(
  AppState.ConfirmVehicle,
  new NavigationServiceState(AppState.SelectService, (state) => {
    if (state.localGroup === "ECC") {
      return AppState.MemberSearch;
    }
    return AppState.MemberInformation;
  }),
);

// WHAT (Service)
DefaultNavigationServiceV2.states.set(
  AppState.SelectService,
  new NavigationServiceState((webAppState) => {
    // if (
    //   webAppState.towReasonRestricted &&
    //   webAppState.Service.toUpperCase() === "TOW"
    // ) {
    //   return AppState.TowReason;
    // } else {
    //   return AppState.LocateUser;
    // }
    return AppState.LocateUser;
  }, AppState.ConfirmVehicle),
);

// WHERE (Origin)
DefaultNavigationServiceV2.states.set(
  AppState.LocateUser,
  new NavigationServiceState((state) => {
    return state.Service.toUpperCase() === "TOW" ? AppState.SelectDestination : AppState.ConfirmInformation;
  }, AppState.SelectService),
);

// WHERE (Dest)
DefaultNavigationServiceV2.states.set(
  AppState.SelectDestination,
  new NavigationServiceState(AppState.ConfirmInformation, AppState.LocateUser),
);

// Confirm Screen
DefaultNavigationServiceV2.states.set(
  AppState.ConfirmInformation,
  new NavigationServiceState(AppState.LocatingProvider, (state) => {
    return state.Service.toUpperCase() === "TOW" ? AppState.SelectDestination : AppState.LocateUser;
  }),
);
NavigationService.partnerNaviServices.set("APA", DefaultNavigationServiceV2);
NavigationService.partnerNaviServices.set("APIA", DefaultNavigationServiceV2);
NavigationService.partnerNaviServices.set("APEX", DefaultNavigationServiceV2);
NavigationService.partnerNaviServices.set("ARIC", DefaultNavigationServiceV2);
NavigationService.partnerNaviServices.set("ARIU", DefaultNavigationServiceV2);
NavigationService.partnerNaviServices.set("ATF", DefaultNavigationServiceV2);
NavigationService.partnerNaviServices.set("ATT", DefaultNavigationServiceV2);
NavigationService.partnerNaviServices.set("BMO", DefaultNavigationServiceV2);
NavigationService.partnerNaviServices.set("BWC", DefaultNavigationServiceV2);
NavigationService.partnerNaviServices.set("CARP", DefaultNavigationServiceV2);
NavigationService.partnerNaviServices.set("CARS", DefaultNavigationServiceV2);
NavigationService.partnerNaviServices.set("CGW", DefaultNavigationServiceV2);
NavigationService.partnerNaviServices.set("CH", DefaultNavigationServiceV2);
NavigationService.partnerNaviServices.set("CIBC", DefaultNavigationServiceV2);
NavigationService.partnerNaviServices.set("CIA", DefaultNavigationServiceV2);
NavigationService.partnerNaviServices.set("CP", DefaultNavigationServiceV2);
NavigationService.partnerNaviServices.set("CRE", DefaultNavigationServiceV2);
NavigationService.partnerNaviServices.set("CRR", DefaultNavigationServiceV2);
NavigationService.partnerNaviServices.set("CYSU", DefaultNavigationServiceV2);
NavigationService.partnerNaviServices.set("DAA", DefaultNavigationServiceV2);
NavigationService.partnerNaviServices.set("DCAP", DefaultNavigationServiceV2);
NavigationService.partnerNaviServices.set("DH", DefaultNavigationServiceV2);
NavigationService.partnerNaviServices.set("DRIVO", DefaultNavigationServiceV2);
NavigationService.partnerNaviServices.set("ECC", DefaultNavigationServiceV2);
NavigationService.partnerNaviServices.set("EFG", DefaultNavigationServiceV2);
NavigationService.partnerNaviServices.set("ESTRA", DefaultNavigationServiceV2);
NavigationService.partnerNaviServices.set("FIMC", DefaultNavigationServiceV2);
NavigationService.partnerNaviServices.set("GKW", DefaultNavigationServiceV2);
NavigationService.partnerNaviServices.set("GMI", DefaultNavigationServiceV2);
NavigationService.partnerNaviServices.set("GST", DefaultNavigationServiceV2);
NavigationService.partnerNaviServices.set("JIC", DefaultNavigationServiceV2);
NavigationService.partnerNaviServices.set("JPLU", DefaultNavigationServiceV2);
NavigationService.partnerNaviServices.set("JPLC", DefaultNavigationServiceV2);
NavigationService.partnerNaviServices.set("LDS", DefaultNavigationServiceV2);
NavigationService.partnerNaviServices.set("LIS", DefaultNavigationServiceV2);
NavigationService.partnerNaviServices.set("LMC", DefaultNavigationServiceV2);
NavigationService.partnerNaviServices.set("MER", DefaultNavigationServiceV2);
NavigationService.partnerNaviServices.set("MJMC", DefaultNavigationServiceV2);
NavigationService.partnerNaviServices.set("MLI", DefaultNavigationServiceV2);
NavigationService.partnerNaviServices.set("MMC", DefaultNavigationServiceV2);
NavigationService.partnerNaviServices.set("BTRIN", DefaultNavigationServiceV2);
NavigationService.partnerNaviServices.set("NFI", DefaultNavigationServiceV2);
NavigationService.partnerNaviServices.set("OGIA", DefaultNavigationServiceV2);
NavigationService.partnerNaviServices.set("PG", DefaultNavigationServiceV2);
NavigationService.partnerNaviServices.set("R66", DefaultNavigationServiceV2);
NavigationService.partnerNaviServices.set("TD", DefaultNavigationServiceV2);
NavigationService.partnerNaviServices.set("TIM", DefaultNavigationServiceV2);
NavigationService.partnerNaviServices.set("PORTAL_USER", DefaultNavigationServiceV2);
NavigationService.partnerNaviServices.set("APCO", DefaultNavigationServiceV2);

export { NavigationServiceState, DefaulNavigationService };
